const form_data = (values) => {
    // 如果已经是 FormData 对象，直接返回
    if (values instanceof FormData) {
        return values;
    }
    let formData = new FormData();
    for (let key in values) {
    //    if (values[key]) {
            formData.append(`${key}`, `${values[key]}`);
    //    }
    }
    return formData
}

export default form_data;